export const featuredItemsField = (locales: string[]): "itemsRelationEn"[] =>
  getRelFields("itemsRelation", locales as "En"[]);

export const getRelFields = <Field extends string, Locale extends string>(field: Field, locales?: Locale[]) =>
  locales ? locales.map(l => (field + l.split("-").map(capitalize).join("")) as `${Field}${Capitalize<Locale>}`) : [];

const capitalize = (s: string) => s[0].toLocaleUpperCase() + s.slice(1);
